import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

const baseUrl = process.env.REACT_APP_SERVER_URL;


export const PressApi = createApi({
    reducerPath: 'Press',
    baseQuery: fetchBaseQuery({ baseUrl }),
    endpoints: (builder) => ({

        AllPress: builder.query({
            query: ({ page, title }) => {
                return {
                    url: title ? `/all-press?title=${title}&page=${page}` : `/all-press?page=${page}`,
                    method: 'Get',
                }
            },

        }),

        pressDetails: builder.query({
            query: (slug) => {
                return {
                    url: `/single-press?slug=${slug}`,
                    method: 'Get',
                }
            },

        }),

    })
});

export const {
    useAllPressQuery,
    usePressDetailsQuery

} = PressApi